/**
 * Utilidad para construir rutas de la app según el host.
 * En web.applaby.com o localhost las URLs llevan el pathId (ej: /mi-slug/shop/cart).
 * En dominios custom no llevan pathId (ej: /shop/cart).
 */

import { withTemplateQuery } from "./templateOverride";

/**
 * Indica si el host actual debe usar el prefijo pathId en las rutas.
 * Solo web.applaby.com y localhost usan pathId en la URL.
 */
export function isPathIdPrefixHost() {
	if (typeof window === "undefined") return true; // SSR: asumir con prefijo
	const hostname = window.location.hostname;
	return hostname === "web.applaby.com" || hostname === "localhost";
}

/**
 * Devuelve la ruta de la app con o sin prefijo pathId según el host.
 * Si hay un override de plantilla activo (?template=), lo mantiene en la URL.
 * @param {string} pathIdOrAppId - slug/pathId o appId del sitio
 * @param {string} path - ruta relativa (con o sin / inicial), ej: '/shop/cart', 'menu'
 * @returns {string} - ruta absoluta para navegar o enlazar
 */
export function getAppPath(pathIdOrAppId, path) {
	const normalized = path.startsWith("/") ? path : `/${path}`;
	const base =
		isPathIdPrefixHost() && pathIdOrAppId
			? `/${pathIdOrAppId}${normalized}`
			: normalized;
	return withTemplateQuery(base);
}

/**
 * Regex para extraer el productId de la URL actual (pathname).
 * Compatible con formato /pathId/shop/product/123 y /shop/product/123.
 * @param {string} pathId - pathId actual (solo se usa si isPathIdPrefixHost())
 */
export function getShopProductPathRegex(pathId) {
	if (isPathIdPrefixHost() && pathId) {
		return new RegExp(`/${pathId}/shop/product/([^/]+)`);
	}
	return /\/shop\/product\/([^/]+)/;
}
